const swiper = new Swiper(".swiper:not(#cart-slider)", {
  direction: "horizontal",
  loop: true,
  slidesPerView: 1,
  speed: 400,
  spaceBetween: 10,
  autoplay: {
    delay: 4000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1600: {
      slidesPerView: 5,
    },
    1440: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
  },
});

const UTILS = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, "text/html");
    return doc.body;
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },
};

(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const productRowSection = document.querySelectorAll(
      ".product-row__section"
    );

    productRowSection.forEach((section) => {
      const productButtons = section.querySelectorAll(
        ".toggle-collection__container button"
      );
      const productRows = section.querySelectorAll(".product-row__toggle");
      const productButtonsLink = section.querySelectorAll(
        ".product-button__toggle"
      );
      productButtons.forEach((button, index) => {
        button.addEventListener("click", () => {
          productButtons.forEach((button) => {
            button.classList.remove("toggle-collection__active");
          });
          productRows.forEach((row) => {
            row.style.display = "none";
          });
          productButtonsLink.forEach((link) => {
            link.style.display = "none";
          });
          productButtons[index].classList.add("toggle-collection__active");
          productRows[index].style.display = "grid";
          productButtonsLink[index].style.display = "flex";
        });
      });
    });
  });
  document.addEventListener("alpine:init", () => {
    Alpine.data("ProductGroups", () => ({
      mounted() {
        (async () => {
          let res = await fetch("/?sections=product-groups").then((res) =>
            res.json()
          );
          let $res = UTILS.ConvertStringToHTML(res["product-groups"]);
          UTILS.ConvertStringToJS(
            $res.querySelector("[data-product_groups]").innerHTML
          );
          document.dispatchEvent(new CustomEvent("product-groups-loaded"));
        })();
      },
    }));

    Alpine.data("ColorSwatches", () => ({
      mounted() {
        let am = this;
        am.LoadSwatches();
        document.addEventListener(
          "product-groups-loaded",
          am.LoadSwatches.bind(am)
        );
      },
      LoadSwatches() {
        if (typeof PRODUCT_GROUPS == "undefined") return;

        let am = this;
        let product_handle = am.$el.dataset.product;
        let group = PRODUCT_GROUPS.find((group) => {
          return (
            group.products
              .map((p) => p.handle.join(""))
              .indexOf(product_handle) !== -1
          );
        });

        // console.log(group)
        // if matching group, add swatches
        if (group) {
          group.products
            // .filter(item => item.handle.indexOf(product_handle) == -1)
            .forEach((item) => {
              if (item.handle.indexOf(product_handle) == -1) {
                am.$el.insertAdjacentHTML("beforeend", item.color_swatch);
              } else {
                am.$el.insertAdjacentElement(
                  "beforeend",
                  am.$el.querySelector("label")
                );
                am.$el.insertAdjacentElement(
                  "beforeend",
                  am.$el.querySelector("input")
                );
                am.$el.insertAdjacentElement(
                  "beforeend",
                  am.$el.querySelector("div.swatch-element")
                );
              }
            });

          am.$el.removeAttribute("x-cloak-op");
        }
      },
    }));
  });
})();
